import OneSignal from 'react-onesignal';

export default async function runOneSignal() {
  await OneSignal.init({ appId: '8c167f40-4cef-46e9-ad71-112e2ad9017d', allowLocalhostAsSecureOrigin: true});
  OneSignal.showSlidedownPrompt();
}